import { render, staticRenderFns } from "./CellsTable.vue?vue&type=template&id=73501db6&scoped=true"
import script from "./CellsTable.vue?vue&type=script&lang=js"
export * from "./CellsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73501db6",
  null
  
)

export default component.exports